// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Prefooter_wrapper__R1OPA {
  position: relative;
}
.Prefooter_wrapper__R1OPA .Prefooter_section__8cJdJ {
  padding: 0 20px;
  margin-top: 60px;
  display: flex;
  align-items: center;
  width: 100%;
  justify-content: space-around;
}
.Prefooter_wrapper__R1OPA .Prefooter_section__8cJdJ .Prefooter_group__BU6dm {
  max-width: 550px;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: baseline;
  gap: 25px;
  margin-left: 100px;
}
.Prefooter_wrapper__R1OPA .Prefooter_section__8cJdJ .Prefooter_group__BU6dm .Prefooter_title__XqYS2 {
  font-family: "DrukWideCyr_heavy";
  font-weight: 900;
  font-size: 40px;
  letter-spacing: 0.03em;
  text-transform: uppercase;
  color: white;
}
.Prefooter_wrapper__R1OPA .Prefooter_section__8cJdJ .Prefooter_group__BU6dm .Prefooter_desc_group__nqNk3 {
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.Prefooter_wrapper__R1OPA .Prefooter_section__8cJdJ .Prefooter_group__BU6dm .Prefooter_desc_group__nqNk3 .Prefooter_desc__22iOT {
  font-family: "HelveticaNeue";
  font-weight: 400;
  font-size: 24px;
  color: white;
}
.Prefooter_wrapper__R1OPA .Prefooter_section__8cJdJ .Prefooter_group__BU6dm .Prefooter_btn__3UmpM {
  border-radius: 8px;
  width: 241px;
  height: 46px;
  background: #fd4c0a;
  font-family: "HelveticaNeue";
  font-weight: 500;
  font-size: 20px;
  line-height: 130%;
  text-transform: capitalize;
  color: white;
  cursor: pointer;
}

@media (max-width: 1000px) {
  .Prefooter_wrapper__R1OPA .Prefooter_section__8cJdJ .Prefooter_group_img__15cl1 {
    width: 60%;
  }
  .Prefooter_wrapper__R1OPA .Prefooter_section__8cJdJ .Prefooter_group__BU6dm {
    margin-left: 0px;
  }
}
@media (max-width: 600px) {
  .Prefooter_wrapper__R1OPA .Prefooter_section__8cJdJ {
    display: flex;
    flex-direction: column;
  }
  .Prefooter_wrapper__R1OPA .Prefooter_section__8cJdJ .Prefooter_group_img__15cl1 {
    width: 100%;
    margin-top: 25px;
  }
  .Prefooter_wrapper__R1OPA .Prefooter_section__8cJdJ .Prefooter_group__BU6dm {
    align-items: center;
  }
  .Prefooter_wrapper__R1OPA .Prefooter_section__8cJdJ .Prefooter_group__BU6dm .Prefooter_title__XqYS2 {
    font-size: 20px;
    text-align: center;
  }
  .Prefooter_wrapper__R1OPA .Prefooter_section__8cJdJ .Prefooter_group__BU6dm .Prefooter_desc_group__nqNk3 {
    text-align: center;
  }
  .Prefooter_wrapper__R1OPA .Prefooter_section__8cJdJ .Prefooter_group__BU6dm .Prefooter_desc_group__nqNk3 .Prefooter_desc__22iOT {
    font-size: 20px;
  }
  .Prefooter_wrapper__R1OPA .Prefooter_section__8cJdJ .Prefooter_group__BU6dm .Prefooter_btn__3UmpM {
    font-size: 16px;
    width: 150px;
    height: 50px;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/Prefooter/Prefooter.module.scss"],"names":[],"mappings":"AAEA;EACE,kBAAA;AADF;AAEE;EACE,eAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,WAAA;EACA,6BAAA;AAAJ;AACI;EACE,gBAAA;EACA,WAAA;EACA,aAAA;EACA,sBAAA;EACA,qBAAA;EACA,SAAA;EACA,kBAAA;AACN;AAAM;EACE,gCAAA;EACA,gBAAA;EACA,eAAA;EACA,sBAAA;EACA,yBAAA;EACA,YAAA;AAER;AAAM;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AAER;AADQ;EACE,4BAAA;EACA,gBAAA;EACA,eAAA;EACA,YAAA;AAGV;AACM;EACE,kBAAA;EACA,YAAA;EACA,YAAA;EACA,mBAAA;EACA,4BAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,0BAAA;EACA,YAAA;EACA,eAAA;AACR;;AAKA;EAGM;IACE,UAAA;EAJN;EAMI;IACE,gBAAA;EAJN;AACF;AAQA;EAEI;IACE,aAAA;IACA,sBAAA;EAPJ;EAQI;IACE,WAAA;IACA,gBAAA;EANN;EAQI;IACE,mBAAA;EANN;EAOM;IACE,eAAA;IACA,kBAAA;EALR;EAOM;IACE,kBAAA;EALR;EAMQ;IACE,eAAA;EAJV;EAOM;IACE,eAAA;IACA,YAAA;IACA,YAAA;EALR;AACF","sourcesContent":["@import \"../../assets/styles/global.scss\";\n\n.wrapper {\n  position: relative;\n  .section {\n    padding: 0 20px;\n    margin-top: 60px;\n    display: flex;\n    align-items: center;\n    width: 100%;\n    justify-content: space-around;\n    .group {\n      max-width: 550px;\n      width: 100%;\n      display: flex;\n      flex-direction: column;\n      align-items: baseline;\n      gap: 25px;\n      margin-left: 100px;\n      .title {\n        font-family: \"DrukWideCyr_heavy\";\n        font-weight: 900;\n        font-size: 40px;\n        letter-spacing: 0.03em;\n        text-transform: uppercase;\n        color: #ffff;\n      }\n      .desc_group {\n        display: flex;\n        flex-direction: column;\n        gap: 10px;\n        .desc {\n          font-family: \"HelveticaNeue\";\n          font-weight: 400;\n          font-size: 24px;\n          color: #ffff;\n        }\n      }\n\n      .btn {\n        border-radius: 8px;\n        width: 241px;\n        height: 46px;\n        background: #fd4c0a;\n        font-family: \"HelveticaNeue\";\n        font-weight: 500;\n        font-size: 20px;\n        line-height: 130%;\n        text-transform: capitalize;\n        color: #ffff;\n        cursor: pointer;\n      }\n    }\n  }\n}\n\n@media (max-width: 1000px) {\n  .wrapper {\n    .section {\n      .group_img {\n        width: 60%;\n      }\n      .group {\n        margin-left: 0px;\n      }\n    }\n  }\n}\n@media (max-width: 600px) {\n  .wrapper {\n    .section {\n      display: flex;\n      flex-direction: column;\n      .group_img {\n        width: 100%;\n        margin-top: 25px;\n      }\n      .group {\n        align-items: center;\n        .title {\n          font-size: 20px;\n          text-align: center;\n        }\n        .desc_group {\n          text-align: center;\n          .desc {\n            font-size: 20px;\n          }\n        }\n        .btn {\n          font-size: 16px;\n          width: 150px;\n          height: 50px;\n        }\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `Prefooter_wrapper__R1OPA`,
	"section": `Prefooter_section__8cJdJ`,
	"group": `Prefooter_group__BU6dm`,
	"title": `Prefooter_title__XqYS2`,
	"desc_group": `Prefooter_desc_group__nqNk3`,
	"desc": `Prefooter_desc__22iOT`,
	"btn": `Prefooter_btn__3UmpM`,
	"group_img": `Prefooter_group_img__15cl1`
};
export default ___CSS_LOADER_EXPORT___;
